import axios from "axios";
import { EditResearchPayload } from "../components/Research/modal/modalEdit";
import { getConfig, getHeader } from "../config/config";

export async function EditResearch(token: string, id: string, payload: EditResearchPayload): Promise<any> {
  try {
    const url = `${getConfig().API_URL}/atualizarPesquisa/${id}`;
    const response = await axios.put(url, payload, getHeader(true, `Bearer ${token}`));
    return { success: true, message: "", result: response.data };
  } catch (error: any) {
    return { success: false, message: error?.response?.data?.error || error.message };
  }
}